module.exports = __webpack_public_path__ + "static/media/suma.9d990905.png";